export const LIST_DG_REVIEW = `homepage/list-dg-review`;
